import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { getOrderById } from "../../api";
import { toast } from "react-toastify";

const PaypalPayment = () => {
  const { orderId } = useParams();
  const [approvalUrl, setApprovalUrl] = useState("");
  const [loading, setLoading] = useState(true);
  let TotalAmount;
  if (!orderId) {
    window.location.href = "/";
  }
  const getOrderData = async () => {
    const orderdata = await getOrderById(orderId);
    if (!orderdata) {
      return toast.error("Unable to Get Order Try Again Later");
    }
    TotalAmount = orderdata.TotalAmount;
    // Make a request to your backend to initiate the PayPal payment
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/ecomm/api/v1/payments/paypal/process`,
        {
          orderId,
          amount: TotalAmount,
        }
      )
      .then((response) => {
        setApprovalUrl(response.data.approvalUrl);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };
  useEffect(() => {
    getOrderData();
  });

  const handlePayment = () => {
    // Redirect the user to the PayPal approval URL to complete the payment
    window.location.href = approvalUrl;
  };

  return (
    <div
      style={{
        height: "50vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loading ? (
        <p>You Will Be redirected to Payment Page Please Wait...</p>
      ) : approvalUrl ? (
        <div className="d-flex flex-column align-items-center justify-content-center">
          <p style={{ marginBottom: "1rem" }}>
            Not yet redirected? Click the button below to proceed to payment.
          </p>
          <button className="btn btn-primary" onClick={handlePayment()}>
            Proceed to Payment
          </button>
        </div>
      ) : (
        <p>Failed to initiate payment. Please try again later.</p>
      )}
    </div>
  );
};

export default PaypalPayment;
